module.exports = __webpack_public_path__ + "static/assets/a0ff7efe85fb5bd6bb0970287c067895.svg";